export default [
  {
    path: "/data-transaksi",
    component: () => import("@/pages/transactions/transaction-list.vue"),
    meta: {
      requiredLevel: ["admin", "loket", "kelurahan"],
    },
  },
  {
    path: "/data-transaksi/create",
    component: () => import("@/pages/transactions/transaction-form.vue"),
    meta: {
      requiredLevel: ["admin", "loket", "kelurahan"],
    },
  },
  {
    path: "/data-transaksi/khusus",
    component: () => import("@/pages/transactions/transaction-essential.vue"),
    meta: {
      requiredLevel: ["admin", "loket", "kelurahan"],
    },
  },
  {
    path: "/data-transaksi/detail/:id",
    component: () => import("@/pages/transactions/transaction-detail.vue"),
    meta: {
      requiredLevel: ["admin", "loket", "kelurahan"],
    },
  },
  {
    path: "/data-transaksi/print/:id",
    component: () => import("@/pages/transactions/transaction-print.vue"),
    meta: {
      requiredLevel: ["admin", "loket", "kelurahan"],
    },
  },
  {
    path: "/data-transaksi/skrd/:id",
    component: () => import("@/pages/transactions/transaction-skrd.vue"),
    meta: {
      requiredLevel: ["admin", "loket", "kelurahan"],
    },
  },
  {
    path: "/data-transaksi/ssrd/:id",
    component: () => import("@/pages/transactions/transaction-ssrd.vue"),
    meta: {
      requiredLevel: ["admin", "loket", "kelurahan"],
    },
  },
];
